import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestService } from '../../../service/request.service';

import { CustomerCountService } from '../../../service/customer-count.service';
import { EmployeeCountService } from '../../../service/employee-count.service';
import { forkJoin, map } from 'rxjs';
import { IUser } from '../../../../../shared/models/users/user.model';
import { UserProfileService } from '../../../../../shared/services/user-profile.service';
import { CompanyCountService } from '../../../service/company-count.service';


@Component({
    standalone: true,
    selector: 'app-stats-widget',
    templateUrl: './statswidget.html',
    imports: [CommonModule],
})
export class StatsWidget implements OnInit {
    totalCount: number = 0;
    employeeCount: number = 0;
    customerCount: number = 0;
    requestCount: number = 0;
    maxCompanyName: string = '';
    maxCompanyCount: number = 0;
    clientNumber: number = 0;
    companyCountt: number = 0;
currentUser$!: IUser | null;
    constructor(private requestService: RequestService, private profileService: UserProfileService,private EmployyeCount: EmployeeCountService, private CustmoerCount: CustomerCountService,private companyCount: CompanyCountService) {
    }



    ngOnInit(): void {

this.profileService.currentUser$.subscribe((user) => {
            this.currentUser$ = user;
        })
        this.getRequestMaxCompanyCount().then(count => {
            this.maxCompanyName = count.maxCompanyName;
            this.maxCompanyCount = count.maxCompanyCount;
        });
        this.getStats()
    }



    getRequestMaxCompanyCount(): Promise<{ maxCompanyName: string, company: string, maxCompanyCount: number; totalRequests: number; }> {
        return this.requestService.requestMaxCompanyCount();
    }



    getStats() {


        forkJoin([
            this.requestService.requestCount(),
            this.EmployyeCount.getEmployeeCount(),
            this.CustmoerCount.getCustomerCount(),
            this.companyCount.getCompanyCount()
        ]).subscribe({
            next: ([requestCount, employeeCount, customerCount, companyCount]) => {
                this.totalCount = employeeCount + customerCount;
                this.employeeCount = employeeCount;
                this.customerCount = customerCount;
                this.requestCount = requestCount;
                this.companyCountt = companyCount;
                console.log('Employees:', employeeCount);
                console.log('Employees:', requestCount);
                console.log('Customers:', customerCount);
                console.log('Companies:', companyCount);
                console.log('Total:', this.totalCount);
            },
            error: (err) => console.error('Error:', err)
        });
    }

}
